module.exports = __webpack_public_path__ + "static/brick-searching-4cb4401a9084eeef7bffd05a95e57c78.gif";